import { render, staticRenderFns } from "./DetailsRequestConsumptionMaterials.vue?vue&type=template&id=10adc952"
import script from "./DetailsRequestConsumptionMaterials.vue?vue&type=script&lang=js"
export * from "./DetailsRequestConsumptionMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports